/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { createRoute } from '@gh/common-shared';
import { SmsTemplateDetailsComponent } from './components/sms-template-details/sms-template-details.component';
import { SmsTemplateListComponent } from './components/sms-template-list/sms-template-list.component';
import { SmsTemplateDetailsBusinessService } from './resources/sms-template-details-business.service';
import { SmsTemplateListBusinessService } from './resources/sms-template-list-business.service';

const routes = [
  createRoute({
    component: SmsTemplateListComponent,
    init: SmsTemplateListBusinessService,
    path: '',
    pathMatch: 'full',
    auth: {
      permission: 'Setup.SmsTemplates.LIST',
    },
  }),
  createRoute({
    component: SmsTemplateDetailsComponent,
    path: 'new',
    leave: true,
    init: SmsTemplateDetailsBusinessService,
    auth: {
      permission: 'Setup.SmsTemplates.CREATE',
    },
  }),
  createRoute({
    component: SmsTemplateDetailsComponent,
    path: ':templateId',
    init: SmsTemplateDetailsBusinessService,
    leave: true,
    auth: {
      permission: 'Setup.SmsTemplates.EDIT_VIEW',
    },
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuilderSetupSmsTemplatesRoutingModule {
}
